function carte_interactive_toggle_panel()
{
    const $panel = document.querySelector('.carte-layout__data-panel');

    if ($panel.classList.contains('carte-layout__data-panel--hidden')) {
        $panel.classList.remove('carte-layout__data-panel--hidden');
    } else {
        $panel.classList.add('carte-layout__data-panel--hidden');
    }

}

on('body', 'click', '.js-toggle-panel', carte_interactive_toggle_panel);
